import { Injectable } from '@angular/core';

import { AuthorizationInterceptor } from 'shared/interceptors/authorization.interceptor';
import { ApplicationType } from 'shared/openapi/models/application-type';
import { CsrfTokenCookieName } from 'shared/openapi/models/csrf-token-cookie-name';
import { InternalAuthBaseService } from 'shared/services/internal-auth-base.service';

@Injectable({ providedIn: 'root' })
export class AdminAuthorizationInterceptor extends AuthorizationInterceptor {
	constructor(authService: InternalAuthBaseService) {
		super(authService);
		this.csrfTokenCookieName = CsrfTokenCookieName.AdminCsrfToken;
		this.applicationType = ApplicationType.Admin;
	}
}
